import React from "react";

const SimpleNotes = () => {
    return (
        <div>
            <h1>Simple Scene Notes</h1>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/ZdTkhLFWbkg?si=h1ChjGJLB7N4PlHe"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>
            <p><a href="https://assetstore.unity.com/packages/tools/level-design/simple-scene-notes-350172">Asset Store
                Link </a></p>

            <p>Simple Scene Notes is a lightweight Unity editor tool that lets you leave notes directly inside your
                scenes. Notes are visible in the Scene view and saved with the scene, making it easy to track TODOs,
                give feedback, or communicate changes without relying on external tools.
            </p>
            Core Features:
            📝 Create in-scene notes directly in the editor
            🔁 Duplicate notes instantly
            💬 Per-note comment threads
            🗂 Built-in note browser with filters
            🎨 Color notes by category, assignee, or status
            🏷 Fully customizable categories, assignees, and statuses
            🧭 Custom editor overlay for fast access and filtering
            ⚡ Lightweight and editor-only (excluded from builds)
            🎯 Designed for speed and ease of use
        </div>
    )
        ;
};

export default SimpleNotes;
